import React, { useEffect, useState } from 'react';
import { Box, Stack, Button, Divider, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// import ExportButton from './ExportButton';
// import ExportPopover from './ExportPopover';
import { API } from '../../../../../../api';
import { useParams } from 'react-router-dom';
// import InsightFilter from './InsightFilter';
import { adminPanel } from '../../../../../../utils/muiStyle';
import ProgramMetricsInsights from './ProgramMetricsInsights';
import UserInsightsCards from './UserInsightsCards'; // new
// import UserInsightsCardsOld from './UserInsightsCardsOld'; //old
import { useAppSelector } from '../../../../../../redux/hooks';
// import { FilterIcon } from '../../../../../../utils/Icons';
import useResponsiveScreenSwitch from '../../../../../../utils/useResponsiveScreenSwitch';
import { getUserDetails } from '../../../../../../utils/orgName';

const ProgramInsights = () => {
  const { forMobile } = useResponsiveScreenSwitch();
  const classs = adminPanel();
  const { id: routeGrpId = '', orgId, coId } = useParams();
  const isAdminRoute = routeGrpId === 'admin';
  const groupData = useAppSelector((state) => state.groupDetails);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [memberInsightValue, setMemberInsightValue] = useState<any>();
  const [metricsValue, setMetricsValue] = useState<any>([]);
  const [userTypes, setUserTypes] = useState<any>([]);
  const [activeGrid, setActiveGrid] = useState<string>('Program Metrics');
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [selectedGroupId, setSelectedGroupId] = useState<string>('');
  const userLocation: string = getUserDetails().location ?? '';

  const handleButtonClick = (tabName: string) => {
    setActiveGrid(tabName);
  };

  const fetchMembersInsightValues = async (groupId: string) => {
    if (!groupId) return;
    setMetricsValue([]);
    setMemberInsightValue(undefined);
    setUserTypes([]);
    try {
      const response = await API.fetchMembersInsights(groupId);
      if (response.status === 200) {
        const payload = response?.data?.data?.[0];
        setMetricsValue(payload);
        setMemberInsightValue(payload?.members);
        const keys = Object.keys(payload?.members || {}).filter((key) => key !== 'total' && key !== 'Unknown');
        setUserTypes(keys);
      }
    } catch (e) {
      console.error('Failed to fetch insights', e);
    }
  };

  const fetchGroupList = async () => {
    try {
      const response = await API.getAllGroups({ orgId: coId ?? '', grpId: '', loc: userLocation, useCache: false });
      const data = response?.data?.data || response?.data || {};
      const groups = Array.isArray(data.groups) ? data.groups : data?.data || [];
      setGroupOptions(groups);
    } catch (error) {
      console.error('Failed to load programs', error);
    }
  };

  useEffect(() => {
    if (groupData?.data) {
      const { currency } = groupData.data;
      setCurrencySymbol(currency);
    }
    fetchGroupList();
  }, [groupData.data, coId, location]);

  useEffect(() => {
    if (!groupOptions.length) return;
    if (routeGrpId && routeGrpId !== 'admin' && selectedGroupId !== routeGrpId) {
      setSelectedGroupId(routeGrpId);
      return;
    }
    if (!selectedGroupId) {
      const fallback = groupOptions[0]?.grpId || groupOptions[0]?.id || '';
      if (fallback) {
        setSelectedGroupId(fallback);
      }
    }
  }, [groupOptions, routeGrpId, selectedGroupId]);

  useEffect(() => {
    if (selectedGroupId) {
      fetchMembersInsightValues(selectedGroupId);
    }
  }, [selectedGroupId]);

  const tabList = ['Program Metrics'];

  const renderGrid = (gridId: string) => {
    if (gridId === 'Program Metrics') {
      return (
        <ProgramMetricsInsights
          metricsValue={metricsValue}
          memberInsightValue={memberInsightValue}
          grpIdOverride={selectedGroupId}
        />
      );
    }
    return <UserInsightsCards tabName={gridId} metricsValue={metricsValue} currencySymbol={currencySymbol} />;
  };

  const buttonStyle = (id: string) =>
    activeGrid === id
      ? {
          background: '#EFF0F4',
          fontWeight: 700
        }
      : {};

  return (
    <Box className={classs.mainBody}>
      <Box display="flex" alignItems="center" justifyContent="space-between" gap="8px" mb={2} flexWrap="wrap">
        <FormControl
          size="small"
          sx={{
            minWidth: 220,
            background: '#131313',
            borderRadius: '6px',
            '& .MuiInputLabel-root': { color: '#FDFDFD' }
          }}
        >
          <InputLabel sx={{ color: '#FDFDFD' }}>Program</InputLabel>
          <Select
            value={selectedGroupId}
            label="Program"
            onChange={(event) => setSelectedGroupId(event.target.value)}
            sx={{ color: '#FDFDFD' }}
          >
            {groupOptions.map((group) => (
              <MenuItem key={group.grpId || group.id} value={group.grpId || group.id}>
                {group.name || group.displayName || 'Unnamed Program'}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack
          borderRadius="8px"
          border="1px solid #EFF0F4"
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
        >
          {tabList.map((tabName) => (
            <Button
              key={tabName}
              sx={{
                width: '115px',
                height: '34px',
                fontSize: '12px',
                fontWeight: '400',
                ...buttonStyle(tabName)
              }}
              onClick={() => handleButtonClick(tabName)}
            >
              {tabName}
            </Button>
          ))}
        </Stack>
      </Box>

      <Box>{activeGrid ? renderGrid(activeGrid) : null}</Box>
    </Box>
  );
};

export default ProgramInsights;
